export const PROPERTIES_SECTION_KEY = 'PROPERTIES';